import { render, staticRenderFns } from "./MediDeptSelect.vue?vue&type=template&id=5a3bf158&"
import script from "./MediDeptSelect.vue?vue&type=script&lang=js&"
export * from "./MediDeptSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3bf158')) {
      api.createRecord('5a3bf158', component.options)
    } else {
      api.reload('5a3bf158', component.options)
    }
    module.hot.accept("./MediDeptSelect.vue?vue&type=template&id=5a3bf158&", function () {
      api.rerender('5a3bf158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/popup/MediDeptSelect.vue"
export default component.exports